import { render, staticRenderFns } from "./IntonationReading.vue?vue&type=template&id=7009a349&scoped=true&"
import script from "./IntonationReading.vue?vue&type=script&lang=js&"
export * from "./IntonationReading.vue?vue&type=script&lang=js&"
import style0 from "./IntonationReading.vue?vue&type=style&index=0&id=7009a349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7009a349",
  null
  
)

export default component.exports